import { Button } from '@material-ui/core';
import styled from 'styled-components';
import { VinDialog } from './VinDialog';
import { VinInfoDialog } from './VinInfoDialog';
import { InitialImageUploadDialog } from './InitialImagesDialog';

export const CreateVehicleDialog = () => {
  return (
    <>
      <VinDialog />
      <VinInfoDialog />
      <InitialImageUploadDialog />
    </>
  );
};
